var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5066 15.4937C15.7424 22.7294 17.8627 20.9979 18.8096 20.3214C18.9627 20.2345 22.4675 17.9761 20.2878 15.7969C15.2323 10.741 16.2581 17.3126 11.4719 12.5274C6.68675 7.74113 13.259 8.76768 8.20346 3.71227C6.02353 1.53237 3.76491 5.03745 3.679 5.18952C3.00162 6.1365 1.2708 8.25801 8.5066 15.4937Z",
    stroke: "#212227",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bbe4bef9c70794c490f46b5127a307ec.svg";
export { ForwardRef as ReactComponent };